import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { isNumber } from 'angular';

@Component({
  selector: 'rl-page-navigation',
  templateUrl: './page-navigation.component.html',
  styleUrls: ['./page-navigation.component.scss']
})
export class PageNavigationComponent{

  @Input() totalPages : number;
  @Input() currentPage : number = 1;
  @Output() pageChanged : EventEmitter<number> = new EventEmitter<number>();
  
  set toPage(page : number){
    if(!isNaN(page)){
      this.pageChanged.emit(page);
      this.currentPage = page;
    }
  }

}
